export default __webpack_public_path__ + "static/media/stationary.779cc783.jpg";